import i18n from "@utils/i18n";

import trackLogo from "../../assets/images/tracklogo_notext.svg";
import style from "./loading.styl";

const LoadingPage = () => {
  return (
    <div className={style.page}>
      <div className={style.logo}>
        <img className={style.logo} src={trackLogo} />
      </div>
      <span className="subtitle dark">{i18n.t("common:loading")}</span>
    </div>
  );
};

export default LoadingPage;
